import './textInput.css';

const TextInput = ({ className, onChange, value, placeholder, id, type = "text", ...props }) => {
    return <input
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`text-input-generic primary-font ${className || ''}`}
        type={type}
        placeholder={placeholder}
        {...props}
    />;
};

export default TextInput;